import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod' 
import {
    Form,
    FormControl,
    FormField,
    FormItem, 
    FormMessage,
} from '@/components/ui/form'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
  } from "@/components/ui/select" 
import Button from '@/components/Button'
import { AxiosError } from 'axios'
import { isAxiosError } from '@/api/business' 
import { useToast } from '@/components/ui/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchInformImpediment } from '@/api/business/cockpit'
import { DetailNFKeys } from '@/queries/useDetailNFQuery'
import { Cockpit } from '@/queries/useCockpitQuery'
import { useImpedimentQuery } from '@/queries/useImpedimentQuery'

interface PropsImpediment { 
    impediment: number | null
    nf: string
}

const impedimentSchema = z.object({
    SK_IMPEDITIVO: z.number() 
})

type impedimentSchemaType = z.infer<typeof impedimentSchema>

export function Impediment( {impediment, nf } : PropsImpediment) { 
    const queryClient = useQueryClient()
    const { toast } = useToast()
     
     let { data: listImpediment }  = useImpedimentQuery()
    
    console.log('impediment',impediment)
    const form = useForm<impedimentSchemaType>({
        resolver: zodResolver(impedimentSchema),
        defaultValues: {
            SK_IMPEDITIVO: impediment || 0, 
        },
    })

    const { mutate: onInformImpediment, isPending } = useMutation({
        mutationFn: fetchInformImpediment,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: DetailNFKeys.detail(nf) })
            queryClient.invalidateQueries({ queryKey: Cockpit.all })
            console.log('success',data)

            toast({
                title: data.body,
                variant: 'success',
            })
        },
        onError: (err: AxiosError) => {
            if (isAxiosError(err)) {
                toast({
                    title: 'Erro ao informar o impedimento',
                    description: 'Tente novamente caso erro persistir entre em contato com o desenvolvimento,',
                    variant: 'destructive',
                })
            }
        },
    })

    const onSubmit = async (data: impedimentSchemaType) => {
        onInformImpediment({
            SK_NF: nf, 
            SK_IMPEDITIVO: data.SK_IMPEDITIVO 
        })
    }
  
    return ( 
        <Form {...form}>
            <form
                className="grid gap-4"
                onSubmit={form.handleSubmit(onSubmit)}
            > 
                <FormField
                    name="SK_IMPEDITIVO"
                    control={form.control}
                    render={({ field }) => (    
                            <FormItem> 
                            <Select onValueChange={(value) => field.onChange(Number(value))} defaultValue={field.value.toString()}>
                                <FormControl>
                                    <SelectTrigger>
                                    <SelectValue placeholder="" />
                                    </SelectTrigger>
                                </FormControl>
                                <SelectContent>
                                    {listImpediment?.map((item) => (
                                        <SelectItem key={item.SK_IMPEDITIVO} value={item.SK_IMPEDITIVO.toString()}>{item.DS_IMPEDITIVO}</SelectItem>
                                    ))}  
                                </SelectContent>
                            </Select>
                            <FormMessage />
                        </FormItem>
                    )}
                />   
                <div className='flex items-end'>
                    <Button className="w-full md:py-3 bg-black hover:bg-gray-900" size={'sm'}  isLoading={isPending}>
                        Salvar
                    </Button> 
                </div>
            </form>
        </Form>
    
    );
}